export default {
    'section': {
        // 'key': 'value',
    },
};